/**
 * Created by richard on 7/14/14.
 */
var feedbackModel = angular.module('feedbackModel', ['schoolModel']);
feedbackModel.factory('FeedbackModel', function(ApplicationService, SchoolModelFactory){
    var FeedbackModel = function(){
        this.endpoint = "/Feedback";
        this.primaryKey = "recordID";
    }
    FeedbackModel.prototype = new SchoolModelFactory();
    FeedbackModel.prototype.parent = SchoolModelFactory.prototype; 
    return FeedbackModel;
});


feedbackModel.service('FeedbackModelService', function(FeedbackModel){
    var feedbackModel = new FeedbackModel();
    return feedbackModel;
});


